import {configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import {thunk} from "redux-thunk"
import authSlice from '../features/auth/auth-slice'
import mapSlice from '../features/map/map-slice'
import chatSlice from '../features/chat/chat-slice'
import appSlice  from './app-slice'

export const store = configureStore({
    reducer: {
      auth: authSlice,
      map: mapSlice,
      chat: chatSlice,
      app: appSlice
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;